import React from 'react';
import styles from './AdminPostList.module.scss';
import AdminTableList from '../../../components/admin/AdminTableList/AdminTableList';
import { userList } from '../../../redux/actions/user/userList';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { postList } from '../../../redux/actions/app/postList';
import Player from 'react-player';

const AdminPostList = () => {
  const columns = [
    {
      label: 'Фото/Видео',
      onTransform: (val) => (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100px', height: '100px' }}>
          {val.mimeType.includes('video') ? (
            <Player
              className="Video"
              url={val.attachment}
              height={'100px'}
              width={'100px'}
              controls={true}
              config={{
                file: {
                  forceVideo: true,
                },
              }}
            />
          ) : (
            <Box component={'img'} src={val?.attachment} sx={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '6px', margin: '0 auto' }}></Box>
          )}
        </Box>
      ),
    },
    {
      label: 'Описание',
      onTransform: (val) => <Box sx={{ textAlign: 'left', maxWidth: '300px', width: '300px', whiteSpace: 'normal' }}>{val?.text}</Box>,
    },
    {
      label: 'Автор',
      onTransform: (val) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginRight: 'auto' }}>
          <Box component={'img'} src={val?.creator?.avatar} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
          <Box>{`${val?.creator?.lastName} ${val?.creator?.firstName}`}</Box>
        </Box>
      ),
    },

    {
      label: 'Дата создания',
      onTransform: (val) => (val?.createdAt ? dayjs(val?.createdAt).format('DD.MM.YYYY HH:mm') : '-'),
    },
  ];
  return (
    <div>
      <AdminTableList title={'Посты'} sliceName={'app'} actionName={'postList'} fetch={postList} pathEdit="/admin/post/edit" columns={columns} textEmpty={'Постов нет'} />
    </div>
  );
};

export default AdminPostList;
